import { Modal, Stack, Typography, Button } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";

export default function SuccessResetPasswordModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        borderRadius={"16px"}
        style={{
          width: "600px",
        }}
      >
        <Stack textAlign={"justify"} p={"40px 32px"}>
          <Typography fontSize={"25px"} fontWeight={700} mb={"18px"}>
            Senha redefinida com sucesso!
          </Typography>

          <Typography
            fontSize={"14px"}
            fontWeight={500}
            color="#636363"
            align="justify"
            lineHeight={"100%"}
          >
            Você será automaticamente redirecionado à tela de login para acesso
            ao portal Consigaz.
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              color: "#fff",
              height: "45px",
              borderRadius: "36px",
              marginTop: "42px",
              p: "10px",
            }}
            fullWidth
            onClick={onClose}
          >
            Voltar ao Login
          </Button>
        </Stack>
      </ContentModal>
    </Modal>
  );
}
